import { Component, OnDestroy, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { PersonSelectorService } from "../../../personselector/personselector.service";
import { DataService_Parent_PortalAppReg } from "../shared/data.service";
import { PAEmailMultipleRequest } from "../shared/pa-email-multiple-request";
import { PersonRegisteredUsersRequest } from "../shared/person-registered-users-request";
import { RegPersonToggleRequest } from "../shared/reg-person-toggle-request";

@Component({
	selector: "caass-parent-portal-by-student-mode",
	templateUrl: "./parent-portal-by-student-mode.component.html",
	styleUrls: ["./parent-portal-by-student-mode.component.css"],
})
export class ParentPortalByStudentModeComponent implements OnInit, OnDestroy {
	constructor(
		private personselectorService: PersonSelectorService,
		private dataService: DataService_Parent_PortalAppReg,
		private confirmationService: ConfirmationService
	) {}

	ngOnDestroy(): void {
		this.subscriptionPersonSelect.unsubscribe();
	}

	ngOnInit(): void {
		this.subscriptionPersonSelect = this.personselectorService.onPersonSelectChange().subscribe((person) => {
			this.SelectedStudent = person;
			this.loadGuardians();
			this.loadRegisteredUsers();
		});

		if (this.SelectedStudent != undefined) {
			this.loadGuardians();
			this.loadRegisteredUsers();
		}
	}

	////////////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////////////

	subscriptionPersonSelect: any;
	SelectedStudent: any;

	LoadingGuardian: boolean = false;
	lstGuardian: any = [];

	guardianpagerows: any = 10;
	guardianpagefirst: any = 0;
	// lstHasEmailDesc: any = [];

	LoadingRegUser: boolean = false;
	lstRegUser: any = [];
	SelectedRegUser: any;

	reguserpagerows: any = 10;
	reguserpagefirst: any = 0;
	lstLanguageDesc: any = [];
	lstRegPersonActiveDesc: any = [];

	Processing: boolean = false;
	ErrorMessage: string = "";

	////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////////////////

	loadGuardians() {
		this.ErrorMessage = "";
		this.lstGuardian = [];

		if (this.SelectedStudent == undefined || this.SelectedStudent.PersonID == undefined || this.SelectedStudent.PersonID <= 0) {
			return;
		}

		this.LoadingGuardian = true;

		var result = this.dataService.PortalAppStudentGuardianSelectList(this.SelectedStudent.PersonID);
		result.subscribe(
			(response) => {
				this.lstGuardian = response;

				// this.lstHasEmailDesc = Array.from(new Set(this.lstGuardian.map((item: any) => item.HasEmailDesc)));

				this.LoadingGuardian = false;
			},
			(error) => {
				this.LoadingGuardian = false;
			}
		);
	}

	loadRegisteredUsers() {
		this.lstRegUser = [];

		if (this.SelectedStudent == undefined || this.SelectedStudent.PersonID == undefined || this.SelectedStudent.PersonID <= 0) {
			return;
		}

		var parms: PersonRegisteredUsersRequest = {
			Token: "", // Filled in by server
			PersonID: this.SelectedStudent.PersonID,
			Domain: "", // Filled in by server
			RegAppTypeID: 1, // Parent App
		};

		this.LoadingRegUser = true;

		var result = this.dataService.PersonRegisteredUsersSelectList(parms);
		result.subscribe(
			(response) => {
				this.lstRegUser = response;

				this.lstLanguageDesc = Array.from(new Set(this.lstRegUser.map((item: any) => item.LanguageDesc))).sort();
				this.lstRegPersonActiveDesc = Array.from(new Set(this.lstRegUser.map((item: any) => item.RegPersonActiveDesc))).sort();

				this.LoadingRegUser = false;
			},
			(error) => {
				this.LoadingRegUser = false;
			}
		);
	}

	////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////////////////
	onDelete(ID) {
		this.lstGuardian = this.lstGuardian.filter((g) => g.ID != ID);
	}

	onAddGuardian() {
		this.ErrorMessage = "";

		if (this.SelectedStudent == undefined || this.SelectedStudent.PersonID == undefined || this.SelectedStudent.PersonID <= 0) {
			this.ErrorMessage = "Select a Student";
			return;
		}

		var nextID = 0;
		for (var z = 0; z < this.lstGuardian.length; z++) {
			var next = this.lstGuardian[z];

			if (next.ID >= nextID) {
				nextID = next.ID + 1;
			}
		}

		var nextGuardian = {
			ID: nextID,
			ParentName: "",
			Email: "",
		};

		this.lstGuardian = [...this.lstGuardian, nextGuardian];
	}

	onSendEmails() {
		this.ErrorMessage = "";

		if (this.SelectedStudent == undefined || this.SelectedStudent.PersonID == undefined || this.SelectedStudent.PersonID <= 0) {
			this.ErrorMessage = "Select a Student";
			return;
		}

		this.lstGuardian = this.lstGuardian.filter((g) => g.ParentName != "" || g.Email != "");
		if (this.lstGuardian.length == 0) {
			this.ErrorMessage = "Add guardians and fill in their information in the table";

			var nextGuardian = {
				ID: 0,
				ParentName: "",
				Email: "",
			};

			this.lstGuardian = [...this.lstGuardian, nextGuardian];
			return;
		}

		var lstWithEmails = this.lstGuardian.filter((g) => g.Email != "" && g.Email != undefined);
		var NoEmailCount = this.lstGuardian.length - lstWithEmails.length;

		if (NoEmailCount > 0) {
			if (NoEmailCount == this.lstGuardian.length) {
				this.ErrorMessage = "Fill in guardian emails to send them a registration code";
				return;
			} else {
				this.ConfirmNoEmails(NoEmailCount, lstWithEmails);
			}
		} else {
			this.ConfirmSendEmail(lstWithEmails);
		}
	}

	ConfirmNoEmails(NoEmailCount, lstWithEmails) {
		var Msg =
			NoEmailCount +
			" guardian" +
			(NoEmailCount == 1 ? "" : "s") +
			" don't have their email filled in and WON'T BE EMAILED. Are you sure you want to continue?";

		this.confirmationService.confirm({
			key: "parentportalpreconfirm",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: Msg,
			header: "Skipping Guardians with No Emails",
			icon: "fa",
			accept: () => {
				this.ConfirmSendEmail(lstWithEmails);
			},
		});
	}

	ConfirmSendEmail(lstWithEmails) {
		var Msg =
			"You are about to send " + lstWithEmails.length + " registration email" + (lstWithEmails.length == 1 ? "" : "s") + ". Do you want to continue?";

		this.confirmationService.confirm({
			key: "parentportalconfirm",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: Msg,
			header: "Confirm Email Guardians",
			icon: "fa",
			accept: () => {
				this.FinishSendEmails(lstWithEmails);
			},
		});
	}

	FinishSendEmails(lstWithEmails) {
		var lstEmail = lstWithEmails.map((g) => g.Email);

		var parms: PAEmailMultipleRequest = {
			AppID: 1,
			lstEmail: lstEmail,
			PersonID: this.SelectedStudent.PersonID,
		};

		this.Processing = true;

		var result = this.dataService.PortalAppQRCodeEmailMultiple(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					this.confirmationService.confirm({
						key: "parentportal",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: response.SuccessCount + " emails were sent successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {},
					});
				} else {
					var strErr = "";

					for (var z = 0; z < response.lstErrorMessage.length; z++) {
						strErr += response.lstErrorMessage[z];

						if (z < response.lstErrorMessage.length - 1) {
							strErr += "; ";
						}
					}

					this.confirmationService.confirm({
						key: "parentportal",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Unable to send " + response.lstErrorMessage.length + " emails: " + strErr,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onUpdateRegPerson(RegUser: any, ChangeTo: number) {
		var parms: RegPersonToggleRequest = {
			RegUserID: RegUser.RegUserID,
			UserID_Email: RegUser.UserID_Email,
			PersonID: this.SelectedStudent.PersonID,
			Active: ChangeTo,
		};

		this.Processing = true;

		var result = this.dataService.RegPersonToggle(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				var Msg: string = "";

				if (response.Success == true) {
					if (ChangeTo == 0) {
						Msg = "Access was removed from " + String(RegUser.FirstName + " " + RegUser.LastName).trim() + " successfully. ";
						Msg += "Note: Any QR codes that were emailed to that user have been deactivated.";
					} else {
						Msg = "Access was re-enabled for " + String(RegUser.FirstName + " " + RegUser.LastName).trim() + ". ";
						Msg += "Note: They won't have to re-register and will be able to see the student next time they log in to the portal app.";
					}

					this.confirmationService.confirm({
						key: "parentportal",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: Msg,
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadRegisteredUsers();
						},
					});
				} else {
					if (ChangeTo == 0) {
						Msg = "Unable to remove access: ";
					} else {
						Msg = "Unable to re-enable access: ";
					}

					this.confirmationService.confirm({
						key: "parentportal",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: Msg + response.Message,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////////////////

	IsLoading() {
		return this.LoadingGuardian == true || this.Processing == true;
	}

	////////////////////////////////////////////////////////
}
